import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Fabrication from "./Exercise05/Fabrication";
import Fabisp from "./Exercise05/Fabisp";
import Assembly from "./Exercise05/Assembly";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

function SimpleCard(props) {
  const { classes } = props;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Feb 13, 2019
          </Typography>
          <Typography variant="h5" component="h2">
            Electronics Production
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            PCB fabrication, PCB materials, board houses, components,
            breadboards, assembly, CAM
          </Typography>
          <Typography component="p">
            group assignment:
            <br />
            {
              '"characterize the design rules for your PCB production process individual assignment:"'
            }
            <br />
            individual assignment:
            <br />
            {
              '"make an in-circuit programmer by milling the PCB,check if you can program it, then optionally try other PCB processes"'
            }
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            href="http://academy.cba.mit.edu/classes/electronics_production/index.html"
            target="_blank"
            size="small"
          >
            Learn More
          </Button>
        </CardActions>
        <Divider />
      </Card>
      <br />
      <div className={classes.root}>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>PCB fabrication</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Fabrication />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>Assembly</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Assembly />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>FabTinyISP</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Fabisp />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
